<template>
  <div class="page">
    <HeaderComponent />
    <slot />
    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent';
import FooterComponent from '@/components/FooterComponent';

export default {
  name: 'DefaultLayout',
  components: {
    HeaderComponent,
    FooterComponent,
  },
};
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.page > .content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
